import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import BudgetChangeRequestTable from './BudgetChangeRequestTable';
import './BudgetChangeRequest.scss';

const BudgetChangeRequestPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search || '');
  const projectId = params.get('projectId') || '';
  const projectName = params.get('projectName') || '';

  if (!projectId) {
    return <Navigate to="/delivery/project-details" replace />;
  }

  return (
    <div className="budget-change-request-page">
      <BudgetChangeRequestTable projectId={projectId} projectName={projectName} />
    </div>
  );
};

export default BudgetChangeRequestPage;
